<div class="grid">
  <div class="col-6">
    <span class="label-small">
      <strong>Initiator</strong>
      {{ initiator }}
    </span>
  </div>
  <div class="col-6">
    <span class="label-small">
      <strong>Participants</strong>
      <ng-container *ngFor="let email of allRecipientEmails">
        {{ email }}<br />
      </ng-container>
    </span>
  </div>
  <div class="col-12">
    <p class="label-small" [innerHTML]="sanitizedDetails"></p>
  </div>
</div>
